export default "__VITE_ASSET__eVmQmb95__"